SupportFinePrintPresenterPresentation = require('../../presenters/fine_print_presenter')
Backbone = require 'backbone'
Backbone.$ = $
SupportFinePrintTemplate = require('../../../fine_print.html.mustache')

class SupportFinePrintView extends Backbone.View
  id: 'popupContent'

  initialize: ->
    @I18nScope = 'modules.support'
    @template = SupportFinePrintTemplate

  render: ->
    @popup = $('#popup')
    GIG.Modal.open
      el: @popup
      closeOnBgClick: true
      closeOnEscKey: true

    @$el.html toHtml(@template, @toHash(), @I18nScope)
    @popup.html(this.el)
    openLinksInNewTab($('#popupContent a'))

  toHash: ->
    fine_print: Groupon.Support.currentOrder.finePrintText || Groupon.Support.currentOrder.deal?.finePrintText

  closeModal: ->
    GIG.Modal.close()
    return false

  events:
    'click .close-modal' : "closeModal"

module.exports = SupportFinePrintView
